import React from "react";
import { useTheme } from "@emotion/react";
import Typography from "@mui/material/Typography";

/**
 * 
 * @returns A loading component
 */
export default function Loading() {
    const theme = useTheme();
    return <Typography>Loading...</Typography>
}